export enum ButtonColor {
    Inherit = 'inherit',
    Primary = 'primary',
    Secondary = 'secondary',
}
